import React from 'react'
import styled from 'styled-components'
import { down } from 'styled-breakpoints'
import { useTranslation } from 'next-i18next'
import Wingie10YearsGreenLogo from './Wingie10YearsGreenLogo'
import { getAnniversarySvgUrl } from './anniversaryAssets'

const BadgeRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 12px;
`

const Badge = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  line-height: 0;
  flex-shrink: 1;
  min-width: 0;

  img {
    width: auto;
    height: 28px;
    display: block;
    max-width: 100%;
  }

  ${down('md')} {
    img {
      height: 28px;
      width: auto;
      max-width: 100%;
    }
  }
`

const Celebrating10YearsBadge: React.FC = () => {
  const { i18n } = useTranslation()
  const src = getAnniversarySvgUrl('celebrating', i18n?.language)

  return (
    <BadgeRow>
      <Badge data-testid="promoted-flight-celebrating-10-years" aria-hidden="true">
        <img src={src} alt="" height={28} decoding="async" />
      </Badge>
      <Wingie10YearsGreenLogo />
    </BadgeRow>
  )
}

export default Celebrating10YearsBadge
